export const en = {
  layout: {
    hello: 'Hello!'
  },
  moduleTitle: {
    news: 'News',
    activity: 'Activity',
    notice: 'Alliance Notice',
    project: 'Recommended Cooperative Projects',
    report: 'Investment Report',
    member: 'Alliance Member',
    partner: 'Cooperation Partners',
    link: 'Friendship Links'
  },
  common: {
    noData: 'No Data',
    searchPlaceholder: 'Please enter keywords to search',
    search: 'Search'
  }
}


// WEBPACK FOOTER //
// ./src/assets/langs/en.js